import { useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {
    UserIcon,
    EnvelopeIcon,
    PhoneIcon,
    MapPinIcon,
    CalendarIcon,
    ClockIcon,
    StarIcon,
} from "@heroicons/react/24/outline";
import BaseTabs from 'components/Base/BaseTabs';
import Review from './Review';

const Tabs = [
    { value: 'Active Jobs' },
    { value: 'Reviews' },
];

const PatientDetails = ({ user }) => {
    const [tab, setTab] = useState(Tabs[0].value);

    return (
        <div className="about">
            <BaseTabs tabs={Tabs} current={tab} onTab={setTab}>
                {tab === 'Active Jobs' && (
                    <div className="space-y-4">
                        {!user.jobs?.length && (
                            <div className="text-center py-8 px-4 bg-white rounded-xl shadow-sm ring-1 ring-slate-100">
                                <div className="bg-gray-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                                    <CalendarIcon className="h-8 w-8 text-gray-400" />
                                </div>
                                <h3 className="text-base font-medium text-gray-900 mb-1">No active jobs</h3>
                                <p className="text-sm text-gray-500 max-w-sm mx-auto">
                                    There are no ongoing care services at the moment.
                                </p>
                            </div>
                        )}

                        {user.jobs?.map((job) => (
                            <Link
                                to={`/jobs/${job._id}`}
                                key={job._id}
                                className="block bg-white rounded-xl p-5 shadow-sm ring-1 ring-slate-100 hover:shadow-md transition-all duration-200"
                            >
                                <div className="flex items-start justify-between mb-3">
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900 mb-2">{job.title}</h3>
                                        <div className="flex items-center gap-4 text-sm text-gray-500">
                                            <div className="flex items-center">
                                                <MapPinIcon className="h-4 w-4 mr-1" />
                                                {job.location.city}
                                            </div>
                                            <div className="flex items-center">
                                                <ClockIcon className="h-4 w-4 mr-1" />
                                                {job.date.length > 1 ? (
                                                    <>{moment(job.date[0]).format("MMM D")} - {moment(job.date[1]).format('MMM D, YYYY')}</>
                                                ) : (
                                                    moment(job.date[0]).format("MMM D, YYYY")
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-lg font-semibold text-sky-600">${job.price}</div>
                                </div>
                                <p className="text-gray-600 text-sm line-clamp-2">{job.description}</p>
                            </Link>
                        ))}
                    </div>
                )}

                {tab === 'Reviews' && (
                    <div className="space-y-4">
                        {!user.reviews?.length && (
                            <div className="text-center py-8 px-4 bg-white rounded-xl shadow-sm ring-1 ring-slate-100">
                                <div className="bg-gray-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                                    <StarIcon className="h-8 w-8 text-gray-400" />
                                </div>
                                <h3 className="text-base font-medium text-gray-900 mb-1">No reviews yet</h3>
                                <p className="text-sm text-gray-500 max-w-sm mx-auto">
                                    This patient hasn't received any reviews from completed services.
                                </p>
                            </div>
                        )}

                        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}
                        {user.reviews?.map((review) => (
                            <div className="list reviews">
                                <Review data={review} key={review._id} />
                            </div>
                        ))}
                        {/* </div> */}
                    </div>
                )}
            </BaseTabs>
        </div>
    );
};

export default PatientDetails;
